import { Box, Grid, TextField, Typography } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useFormikContext } from 'formik';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  CustomSwitchWithText,
  FieldLabel,
  SectionTitle
} from '../components/common';
import useStyles from '../styles';

// Tích truyền QCVN 06:2024/BCA
export default function TransmissionSection({
  isCarType,
  isTransmit,
  onToggleTransmit,
  isInfoTransmit,
  onToggleInfoTransmit
}) {
  const classes = useStyles();
  const { values, touched, errors, handleBlur, handleChange, setFieldValue } =
    useFormikContext();
  const listAgencyBusiness = useSelector(
    state => state.agencySlice.listAgencyBusiness
  );

  return (
    <Box className={classes.sectionCard}>
      <SectionTitle title="Cấu hình tích truyền" />
      {isCarType ? (
        <Grid container spacing={3}>
          <Grid item md={6} xs={12}>
            <Box className={classes.settingItem}>
              <FieldLabel className={classes.settingLabel}>
                Tích truyền QCVN 06:2024/BCA
              </FieldLabel>
              <CustomSwitchWithText
                checked={isTransmit}
                onChange={onToggleTransmit}
                name="isTransmit"
                inputProps={{ 'aria-label': 'transmit' }}
              />
            </Box>
          </Grid>

          {isTransmit && (
            <>
              <Grid item md={6} xs={12}>
                <Box className={classes.settingItem}>
                  <FieldLabel className={classes.settingLabel}>
                    Lấy thông tin từ tài khoản
                  </FieldLabel>
                  <CustomSwitchWithText
                    checked={isInfoTransmit}
                    onChange={onToggleInfoTransmit}
                    name="isInfoTransmit"
                    inputProps={{ 'aria-label': 'account info' }}
                  />
                </Box>
              </Grid>
              <Grid item md={4} xs={12}>
                <FieldLabel required noWrap>
                  Tên đơn vị kinh doanh vận tải
                </FieldLabel>
                <TextField
                  disabled={isInfoTransmit}
                  error={Boolean(
                    touched.business_name && errors.business_name
                  )}
                  size="small"
                  className={`input-no-fieldset ${classes.textField}`}
                  fullWidth
                  helperText={
                    touched.business_name && errors.business_name
                  }
                  margin="normal"
                  name="business_name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.business_name || ''}
                  variant="outlined"
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <FieldLabel required noWrap>Mã số thuế</FieldLabel>
                <TextField
                  disabled={isInfoTransmit}
                  error={Boolean(touched.tax_code && errors.tax_code)}
                  size="small"
                  className={`input-no-fieldset ${classes.textField}`}
                  fullWidth
                  helperText={touched.tax_code && errors.tax_code}
                  margin="normal"
                  name="tax_code"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.tax_code || ''}
                  variant="outlined"
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <FieldLabel required noWrap>
                  Loại hình kinh doanh vận tải
                </FieldLabel>
                <Autocomplete
                  disabled={isInfoTransmit}
                  labelId="business-type-label"
                  id="business-type"
                  size="small"
                  options={listAgencyBusiness || []}
                  getOptionLabel={option => option.title}
                  value={(listAgencyBusiness || []).find(
                    option =>
                      Number(option.id) === Number(values.business_id)
                  )}
                  onChange={(e, value) =>
                    setFieldValue('business_id', value?.id || '')
                  }
                  disableClearable
                  renderInput={params => (
                    <TextField
                      {...params}
                      className={`input-no-fieldset ${classes.textField}`}
                      variant="outlined"
                      margin="normal"
                      placeholder="Chọn loại hình kinh doanh"
                      name="business_id"
                      onBlur={handleBlur}
                      error={Boolean(
                        touched.business_id && errors.business_id
                      )}
                      helperText={
                        touched.business_id && errors.business_id
                      }
                    />
                  )}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <FieldLabel>Số khung</FieldLabel>
                <TextField
                  size="small"
                  className={`input-no-fieldset ${classes.textField}`}
                  fullWidth
                  margin="normal"
                  name="chassis_number"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.chassis_number || ''}
                  variant="outlined"
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <FieldLabel>Số người chuyên chở</FieldLabel>
                <TextField
                  size="small"
                  className={`input-no-fieldset ${classes.textField}`}
                  fullWidth
                  margin="normal"
                  name="passenger_capacity"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.passenger_capacity || ''}
                  variant="outlined"
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <FieldLabel>Tải trọng xe (kg)</FieldLabel>
                <TextField
                  size="small"
                  className={`input-no-fieldset ${classes.textField}`}
                  fullWidth
                  margin="normal"
                  name="max_payload"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.max_payload || ''}
                  variant="outlined"
                />
              </Grid>
            </>
          )}
        </Grid>
      ) : (
        <Typography className={classes.emptyTabText}>
          Thiết bị này không hỗ trợ tích truyền QCVN 06:2024/BCA.
        </Typography>
      )}
    </Box>
  );
}
